"use client"
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { gsap } from 'gsap'
import { useEffect } from 'react'

type UseTxtFillProps = {
  color: string
  containerClass: string
  wordClass: string
}

const useTxtFill = ({color, containerClass, wordClass}: UseTxtFillProps) => {
  useEffect(() => {
    // Đăng ký ScrollTrigger
    gsap.registerPlugin(ScrollTrigger)

    if (typeof window === 'undefined') return

    const timeout = setTimeout(() => {
      const ctx = gsap?.context(() => {
        requestAnimationFrame(() => {
          // Query với class unique cho instance này
          const hasMaskFill: HTMLElement[] = gsap.utils.toArray(`.${containerClass}`)
          hasMaskFill.forEach((hMaskFill) => {
            const words = hMaskFill.querySelectorAll(`.${wordClass}`)
            if (words.length === 0) return
            
            // Animate từng chữ với stagger effect
            gsap.to(words, {
              scrollTrigger: {
                trigger: hMaskFill,
                start: 'top 70%', // Bắt đầu sớm hơn
                end: 'top 30%', // Kết thúc sớm hơn (animation ngắn hơn)
                scrub: 1,
                markers: false, // Set true để debug
              },
              color: color || '#252422',
              duration: 1,
              stagger: {
                each: 0.07, // Giảm delay giữa mỗi chữ (nhanh hơn gấp đôi)
                from: 'start', // Bắt đầu từ chữ đầu tiên
              },
              ease: 'none',
            })
          })
        })
      })

      // Lưu ctx để cleanup
      cleanupCtx = ctx
    }, 100)

    // Cleanup
    let cleanupCtx: any = null
    return () => {
      clearTimeout(timeout)
      if (cleanupCtx) cleanupCtx.revert()
      ScrollTrigger.getAll().forEach((trigger: any) => trigger.kill())
    }
  }, [color, containerClass, wordClass]) // ✅ Thêm containerClass và wordClass vào dependencies
}

export default useTxtFill
